import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleDashed } from '@fortawesome/pro-regular-svg-icons';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons';

interface OngoingCloseBadgeProps {
  isOngoing: boolean;
}

const OngoingCloseBadge: React.FC<OngoingCloseBadgeProps> = ({ isOngoing }) => (
  <span className={`ubc-status-badge${isOngoing ? '' : ' ubc-status-badge--closed'}`}>
    {isOngoing ? 'Ongoing' : 'Closed'}
    <FontAwesomeIcon
      icon={isOngoing ? faCircleDashed : faCircleCheck}
      className={isOngoing ? 'ubc-status-badge-icon' : 'suc-closed-icon'}
    />
  </span>
);

export default OngoingCloseBadge;
